import majors from "../majors";

export const cityOptions = [
  "الرياض",
  "الدرعية",
  "الخرج",
  "المجمعة",
  "الزلفي",
  "شقراء",
  "الدوادمي",
  "القويعية",
  "وادي الدواسر",
  "الأفلاج",
  "حوطة بني تميم",
  "السليل",
  "رماح",
  "ثادق",
  "ضرما",
  "المزاحمية",
  "مرات",
  "عفيف",
  "جدة",
  "مكة المكرمة",
  "مكة",
  "الطائف",
  "رابغ",
  "القنفذة",
  "الليث",
  "خليص",
  "الجموم",
  "أضم",
  "الخرمة",
  "تربة",
  "رنية",
  "المويه",
  "الكامل",
  "بحرة",
  "مدينة الملك عبدالله الاقتصادية",
  "المدينة المنورة",
  "المدينة",
  "ينبع",
  "العلا",
  "بدر",
  "خيبر",
  "الحناكية",
  "مهد الذهب",
  "وادي الفرع",
  "العيص",
  "الدمام",
  "الخبر",
  "الظهران",
  "الأحساء",
  "الهفوف",
  "المبرز",
  "الجبيل",
  "القطيف",
  "رأس تنورة",
  "حفر الباطن",
  "الخفجي",
  "بقيق",
  "النعيرية",
  "قرية العليا",
  "صفوى",
  "سيهات",
  "بريدة",
  "عنيزة",
  "الرس",
  "المذنب",
  "البكيرية",
  "البدائع",
  "الأسياح",
  "رياض الخبراء",
  "عيون الجواء",
  "الشماسية",
  "النبهانية",
  "ضرية",
  "عقلة الصقور",
  "أبها",
  "خميس مشيط",
  "بيشة",
  "محايل عسير",
  "النماص",
  "تنومة",
  "رجال ألمع",
  "سراة عبيدة",
  "ظهران الجنوب",
  "أحد رفيدة",
  "بلقرن",
  "المجاردة",
  "تثليث",
  "طريب",
  "البرك",
  "تبوك",
  "الوجه",
  "ضباء",
  "أملج",
  "تيماء",
  "حقل",
  "البدع",
  "حائل",
  "بقعاء",
  "الغزالة",
  "الشنان",
  "موقق",
  "سميراء",
  "الحائط",
  "الشملي",
  "السليمي",
  "جازان",
  "صبيا",
  "أبو عريش",
  "أحد المسارحة",
  "صامطة",
  "بيش",
  "الدرب",
  "فرسان",
  "ضمد",
  "العارضة",
  "الداير",
  "الريث",
  "الطوال",
  "هروب",
  "نجران",
  "شرورة",
  "حبونا",
  "بدر الجنوب",
  "يدمة",
  "خباش",
  "ثار",
  "الباحة",
  "بلجرشي",
  "المخواة",
  "المندق",
  "قلوة",
  "العقيق",
  "بني حسن",
  "الحجرة",
  "غامد الزناد",
  "سكاكا",
  "القريات",
  "دومة الجندل",
  "طبرجل",
  "عرعر",
  "رفحاء",
  "طريف",
  "العويقيلة",
];

const normalizeName = (value = "") =>
  value
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[أإآا]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ة/g, "ه")
    .replace(/ؤ/g, "و")
    .replace(/ئ/g, "ي")
    .replace(/ـ/g, "")
    .replace(/[\u064B-\u065F]/g, "")
    .replace(/\s+/g, " ");

export const specializationOptions = Array.from(
  majors
    .reduce((optionsMap, majorGroup) => {
      (majorGroup.subMajors || []).forEach((specialization) => {
        const key = normalizeName(specialization);
        const existingOption = optionsMap.get(key);

        if (existingOption) {
          if (!existingOption.categories.includes(majorGroup.name)) {
            existingOption.categories.push(majorGroup.name);
          }
          return;
        }

        optionsMap.set(key, {
          value: specialization,
          label: specialization,
          categories: [majorGroup.name],
        });
      });

      return optionsMap;
    }, new Map())
    .values()
).sort((a, b) => a.label.localeCompare(b.label, "ar"));
